import React from 'react'

const ShowAllPaymentMethods = ({ onClick, showBackToAllPaymentMethodOptions }) => {
  if(!showBackToAllPaymentMethodOptions) {
    return null
  }

  return (
    <div className="go-back">
      <a onClick={onClick}><i className="fa fa-chevron-left" /> Show all payment methods</a>
    </div>
  )
}

export default ShowAllPaymentMethods
